import React, { useEffect } from 'react'
import Home from './Components/Home';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import About from './Components/About';
import Footer from './Components/Footer';
import Price from './Components/Price';
import Services from './Components/Services';
import Navbar from './Components/Navbar';
import Team from './Components/Team';
import ScrollToTop from './Components/ScrollToTop';
import LoadingScreen from './Components/LoadingScreen';
import FloatingWhatsApp from './Components/FloatingWhatsApp';

function App() {
  return (
    <>
      <LoadingScreen />
      <BrowserRouter>
        <Navbar />
        <RouteChangeTracker />
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/pricing" element={<Price />} />
          <Route path="/contact" element={<Home />} />
          <Route path="/offers" element={<Team />} />
        </Routes>
        <Footer />
        <ScrollToTop />
        <FloatingWhatsApp />
      </BrowserRouter>
    </>
  );
}

function RouteChangeTracker() {
  const location = useLocation();

  useEffect(() => {
    if (window.ttq) {
      window.ttq.page();  // Trigger a page event on route change
    }
  }, [location]);

  return null;
}

export default App;
